import { render, staticRenderFns } from "./ErrorButton.vue?vue&type=template&id=1b51a86c&"
import script from "./ErrorButton.vue?vue&type=script&lang=js&"
export * from "./ErrorButton.vue?vue&type=script&lang=js&"
import style0 from "./ErrorButton.vue?vue&type=style&index=0&id=1b51a86c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports